<template>
  <card-item 
    card="item_books" 
    :tabs="tabs" 
    :activeTab="activeTab" 
    :id="id" 
    :infoKeys="infoKeys"/>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
export default {
  methods:{
    cardContent: cardContent,
  },
  props: ["id"],
  async created(){
    let query = Object.assign({}, this.$route.query);
    // this.item = await this.cardContent(`disciplines`, query["item_discipline"])
    // this.$emit('info', {title: '4545', key: 'title'});
    // console.log(this.item, this.item.title, 'this.item.title')
  },
  data() {
    return {
      item: {},
      tabs: [
        // {
        //   key:'info_card',
        //   title: "Информация",
        //   component: () => import("./Info"),
        // },
        {
          key:'books_card',
          title: "Учебники",
          component: () => import("./BooksList"),
        },
        {
          key:'quarters',
          title: "Плановые уроки",
          component: () => import("./Quarters"),
        },
        // {
        //   key:'lessonplans_card',
        //   title: "Плановые уроки",
        //   component: () => import("./DisciplineLessonplan"),
        // },
      ],
      activeTab: 0,
      infoKeys:[
        {
          key: 'course_name',
          title:'Класс',
        },
        {
          key: 'locale',
          title:'Локализация',
        },
      ]
    };
  },
};
</script>